import styled from '@emotion/styled';

export const StyledNavContainer = styled.div`
  display: flow;
`;

export const StyledNavLinkContainer = styled.div`
  padding-left: 5px;
  padding-right: 5px;
`;
